import React, { useEffect, useState } from "react";
import Tooltip from "@mui/material/Tooltip";
import { DataGrid } from "@material-ui/data-grid";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import { confirmAlert } from "react-confirm-alert";
import toast from "react-hot-toast";
import Select from "react-select";
import { monthOptions } from "../../../components/Data/MenuData";

import Modal from "../../../components/Modal/Modal";
import ErrorBoundaryRoutes from "../../../components/shared/ErrorBoundaryRoutes";

//Global state Access
import { useAtom } from "jotai";
import { gbState, fYear } from "../../../components/shared/GlobalState";
import CreateMonthlyStatement from "../Create/CreateMonthlyStatement";

const ListMonthlyStatementsChild = () => {
  let navigate = useNavigate();
  const inputWidth = "250px";
  const [showModal, setShowModal] = useState(false);
  const [currentRecord, setCurrentRecord] = useState({});
  const [selectedMonth, setSelectedMonth] = useState();
  const [data, setData] = useState([]);
  //const [financial_year] = useAtom(fYear);
  const [financial_year, setFinancial_year] = useState();
  const [{ errorLogApi, placeHolderText, user }] = useAtom(gbState);
  const toggleModal = () => {
    setShowModal(!showModal);
  };

  useEffect(() => {
    if (user) {
      setFinancial_year(user?.current_financial_year);
    }
  }, [user]);

  const getDataFromServer = () => {
    let userToken = localStorage.getItem("token");

    let urlLink = `${process.env.REACT_APP_API_URL}/bank-balance/${financial_year}`;

    const config = {
      method: "GET",
      url: urlLink,
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
    };

    axios(config)
      .then(function (response) {
        console.log(JSON.stringify(response.data));
        const oldData = response.data.bankBalances;
        const filteredData = oldData.filter(
          (bb) => bb.financial_year === financial_year?.value
        );
        const updatedData = filteredData.map((data) => {
          return {
            ...data,
            id: data._id,
            month: new Date(data.month).toLocaleString("default", {
              month: "long",
              year: "numeric",
            }),
            opening_balance: data.opening_balance,
            closing_balance: data.closing_balance,
            cash_in_hand: data?.cash_in_hand,
          };
        });

        setData(updatedData);
      })
      .catch(function (err) {
        console.log("error api call ", err?.response?.data);
      });
  };

  const generateStatement = () => {
    // console.log(financial_year);
    if (!financial_year) return toast.error("Please select financial year");
    else if (!selectedMonth) {
      return toast.error("Please Select Month");
    } else {
      navigate("/monthly/statement/add", {
        state: {
          month: selectedMonth,
        },
      });
    }
  };

  return (
    <div className="w-full" style={{ wordBreak: "break-word" }}>
      {/* {JSON.stringify(financial_year)} */}
      <div className="flex flex-row items-center justify-center w-full">
        <div className="mr-5">
          <Select
            name="month"
            onChange={(selected, dropdown) => {
              setSelectedMonth(selected);
            }}
            options={monthOptions}
            placeholder={placeHolderText("Select Month")}
            className={`w-[200px] outline-none`}
            menuPortalTarget={document.body}
            menuPosition={"fixed"}
          />
        </div>
        <div className="">
          <button
            className="px-4 py-2 text-white bg-gray-600 rounded-md hover:bg-gray-900"
            onClick={generateStatement}
          >
            Generate Statement
          </button>
        </div>
      </div>
    </div>
  );
};

export default ListMonthlyStatementsChild;
